import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ComponentStatus, StateComponent } from '../../../../../../common/components/state/state.component';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { FormBettingStatusModel } from '../../../../../../common/apis/form/model/form.model';
import { FormBettingApiService } from '../../../../../../common/apis/form/form-betting-api.service';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

import { MatList, MatListItem } from '@angular/material/list';
import { LoadingContainerComponent } from '../../../../../../common/components/loading-container/loading-container.component';

@Component({
  selector: 'oo-form-submission-status-dialog',
  templateUrl: './form-submission-status-dialog.component.html',
  styleUrls: ['./form-submission-status-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogTitle, MatDialogContent, LoadingContainerComponent, MatList, MatListItem, MatIcon, MatDialogActions, MatButton, MatDialogClose],
})
export class FormSubmissionStatusDialogComponent extends StateComponent<FormSubmissionStatusDialogComponentState> implements OnInit {

  state: FormSubmissionStatusDialogComponentState = {
    status: 'loading',
    compGroupId: undefined!,
    formId: undefined!,
    statuses: [],
  };
  private readonly formApi = inject(FormBettingApiService);
  private readonly dialogRef = inject<MatDialogRef<FormSubmissionStatusDialogComponent>>(MatDialogRef);
  private readonly data = inject<FormSubmissionStatusDialogComponentData>(MAT_DIALOG_DATA);

  constructor() {
    super();

    const data = this.data;
    this.updateState(data);
  }

  ngOnInit(): void {
    this.dialogRef.updateSize('300px', '500px');
    this.fetchData();
  }

  private fetchData(): void {
    this.formApi.getFormSubmissionStatus(this.state.compGroupId, this.state.formId)
      .then((statuses) => {
        this.updateState({
          status: 'ready',
          statuses: statuses.sort(({ submitted }) => !submitted ? -1 : 1),
        });
      })
      .catch((e: Error) => {
        console.error(e);
        this.updateStatus('error');
      });
  }
}

interface FormSubmissionStatusDialogComponentState {
  status: ComponentStatus;
  compGroupId: string;
  formId: string;
  statuses: FormBettingStatusModel[];
}

export interface FormSubmissionStatusDialogComponentData {
  compGroupId: string;
  formId: string;
}
